module.exports = __webpack_public_path__ + "static/img/anxun31.0dce8d3a.png";